import {SwiperOptions} from "swiper";

export const teamConfig: Partial<SwiperOptions> = {
    centeredSlides: true,
    breakpoints: {
        992: {
            slidesPerView: 3,
        },
        1199: {
            slidesPerView: 4,
        },
        1600: {
            slidesPerView: 5,
        },
        1980: {
            slidesPerView: 6,
        },
        2500: {
            slidesPerView: 8,
        },
        3200: {
            slidesPerView: 10,
        },
    }
}
